import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "align-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pl-2 pt-1 pb-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select_filled, {
              modelValue: _ctx.log,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.log) = $event)),
              items: _ctx.logs,
              "item-filter": "filter",
              "hide-details": true,
              readonly: _ctx.readonly,
              density: "compact",
              "item-title": (item) => item.text
            }, null, 8, ["modelValue", "items", "readonly", "item-title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "align-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pl-2 py-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field_filled, {
              "hide-details": true,
              modelValue: _ctx.generalWording,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.generalWording) = $event)),
              label: "Libellé de l'écriture",
              class: "mt-0",
              disabled: !!_ctx.bankTransactionId,
              readonly: _ctx.readonly,
              density: "compact"
            }, null, 8, ["modelValue", "disabled", "readonly"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "align-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pl-2 py-2"
        }, {
          default: _withCtx(() => [
            (!_ctx.bankTransactionId)
              ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                  key: 0,
                  modelValue: _ctx.invoiceNumber,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.invoiceNumber) = $event)),
                  "hide-details": "",
                  label: "N° de pièce",
                  readonly: _ctx.readonly,
                  density: "compact"
                }, null, 8, ["modelValue", "readonly"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "align-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pl-2 pb-2 pt-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_oss_date_picker_filled, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.date) = $event)),
              filterWithoutClosedAccountingPeriods: !_ctx.readonly,
              "hide-details": "",
              label: "Date de l'écriture",
              textFieldReadOnly: false,
              disabled: !!_ctx.bankTransactionId,
              readonly: _ctx.readonly
            }, null, 8, ["modelValue", "filterWithoutClosedAccountingPeriods", "disabled", "readonly"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "align-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pl-2 pb-2 pt-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_oss_date_picker_filled, {
              modelValue: _ctx.dueDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dueDate) = $event)),
              "hide-details": "",
              label: "Date d'échéance",
              textFieldReadOnly: false,
              disabled: !!_ctx.bankTransactionId
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingLines, (al, i) => {
      return (_openBlock(), _createBlock(_component_v_row, {
        key: `divider-${i}`,
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: _ctx.readonly ? 12 : 11
          }, {
            default: _withCtx(() => [
              (_ctx.fullMode)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "pb-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pr-1"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.fullMode)
                            ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                key: 0,
                                "hide-details": true,
                                modelValue: al.wording,
                                "onUpdate:modelValue": ($event: any) => ((al.wording) = $event),
                                onChange: ($event: any) => (_ctx.onItemWordingChanged(al)),
                                class: "pb-1",
                                readonly: _ctx.readonly,
                                disabled: al.isBankTransaction || !!al.tag,
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "readonly", "disabled"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (_ctx.fullMode)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": "",
                    class: "pb-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pr-1"
                      }, {
                        default: _withCtx(() => [
                          (!al.tag)
                            ? (_openBlock(), _createBlock(_component_FreeTag, {
                                key: 0,
                                inPrimaryLog: 'XXXXXX',
                                companyTags: _ctx.companyTags,
                                company: _ctx.selectedCompany,
                                documentType: _ctx.type,
                                accountingLine: al,
                                onOnTagsChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onAccountingLineTagsChanged($event)))
                              }, null, 8, ["companyTags", "company", "documentType", "accountingLine"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(_component_v_chip, {
                                  label: "",
                                  color: "tagFree",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(al.tag.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "pr-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker_filled, {
                            modelValue: al.date,
                            "onUpdate:modelValue": ($event: any) => ((al.date) = $event),
                            filterWithoutClosedAccountingPeriods: !_ctx.readonly,
                            "hide-details": "",
                            readonly: _ctx.readonly,
                            textFieldReadOnly: false,
                            disabled: al.isBankTransaction || !!al.tag,
                            outlined: false,
                            "no-menu": true
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "filterWithoutClosedAccountingPeriods", "readonly", "disabled"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "pl-1"
                      }, {
                        default: _withCtx(() => [
                          (!!al.paymentStatus)
                            ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                key: 0,
                                modelValue: al.dueDate,
                                "onUpdate:modelValue": [($event: any) => ((al.dueDate) = $event), ($event: any) => (_ctx.onDueDateChanged(al, $event))],
                                "hide-details": "",
                                placeholder: "Date d'échéance",
                                textFieldReadOnly: false,
                                disabled: al.isBankTransaction || !!al.tag,
                                notRequired: true,
                                outlined: false,
                                "no-menu": true
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "pb-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pr-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AccountableAccount, {
                        inAccountableAccounts: _ctx.accountableAccounts,
                        thirdParty: al.thirdPartyCompany || al.user || al.bankAccount,
                        "show-validation": false,
                        "hide-details": "",
                        "company-id": _ctx.companyId,
                        "edit-sub-accountable-account": false,
                        label: "Compte comptable",
                        inputStyle: 'padding: 0',
                        disabled: _ctx.readonly || al.isBankTransaction || !!al.tag,
                        editAccountableAccount: true,
                        "onUpdate:modelValue": ($event: any) => (_ctx.setAccountableAccount(al, $event)),
                        defineThirdParty: true,
                        "model-value": al.accountableAccount,
                        rounded: "0"
                      }, null, 8, ["inAccountableAccounts", "thirdParty", "company-id", "disabled", "onUpdate:modelValue", "model-value"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "px-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oss_text_field_filled, {
                        "hide-details": true,
                        outlined: false,
                        rounded: "0",
                        suffix: "D",
                        readonly: _ctx.readonly,
                        onChange: ($event: any) => (_ctx.onItemDebitChanged(al)),
                        rules: [
                                    (v) =>
                                        (v !== '' && parseFloat(v) >= 0.0) ||
                                        _ctx.$t('settings.positiveNumber'),
                                ],
                        disabled: al.isBankTransaction || !!al.tag,
                        modelValue: al.debit,
                        "onUpdate:modelValue": ($event: any) => ((al.debit) = $event)
                      }, null, 8, ["readonly", "onChange", "rules", "disabled", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "pl-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oss_text_field_filled, {
                        "hide-details": true,
                        outlined: false,
                        rounded: "0",
                        suffix: "C",
                        readonly: _ctx.readonly,
                        onChange: ($event: any) => (_ctx.onItemCreditChanged(al)),
                        rules: [
                                    (v) =>
                                        (v !== '' && parseFloat(v) >= 0.0) ||
                                        _ctx.$t('settings.positiveNumber'),
                                ],
                        disabled: al.isBankTransaction || !!al.tag,
                        modelValue: al.credit,
                        "onUpdate:modelValue": ($event: any) => ((al.credit) = $event)
                      }, null, 8, ["readonly", "onChange", "rules", "disabled", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["cols"]),
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                class: "d-flex align-center"
              }, {
                default: _withCtx(() => [
                  (!al.tag)
                    ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                        key: 0,
                        onClick: ($event: any) => (_ctx.deleteRow(al)),
                        size: "small"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_v_divider, {
      class: _normalizeClass({
                'mt-1': _ctx.fullMode,
            }),
      style: {"border-width":"1px"}
    }, null, 8, ["class"]),
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: _ctx.readonly ? 12 : 11
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  class: "pr-2 d-flex align-center body-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _cache[7] || (_cache[7] = _createTextVNode(" Totaux "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { class: "px-2 d-flex align-center body-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalDebit, undefined)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { class: "pl-2 d-flex align-center body-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalCredit, undefined)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["cols"]),
        (!_ctx.readonly)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              class: "d-flex align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_add_icon, {
                  size: "x-small",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addRow()))
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}